import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=147e5f74&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('147e5f74')) {
      api.createRecord('147e5f74', component.options)
    } else {
      api.reload('147e5f74', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=147e5f74&", function () {
      api.rerender('147e5f74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yH2NPZG5IzXu/JS/offershelp.vue"
export default component.exports